// src/services/api.js
import axios from "axios";

/**
 * Regra única para resolver a base da API (ordem de prioridade):
 * 1) Override localStorage ("ovr.api")  -> útil pra troubleshooting sem rebuild
 * 2) window.__ENV.API_BASE              -> se existir um env.js em produção
 * 3) process.env.VUE_APP_API_BASE_URL   -> padrão que definimos nos .env
 * 4) process.env.VUE_APP_API_BASE       -> compat legado (/.env.production antigo)
 * 5) Fallback: "https://api.flexcard.info"
 */
function resolveBase() {
  // 1) Override em runtime (não quebra build)
  try {
    const ovr = localStorage.getItem("ovr.api");
    if (ovr && typeof ovr === "string" && /^https?:\/\//i.test(ovr)) return ovr;
  } catch (_) { /* silencioso */ }

  // 2) window.__ENV (se existir)
  if (typeof window !== "undefined" && window.__ENV && window.__ENV.API_BASE) {
    const w = String(window.__ENV.API_BASE);
    if (/^https?:\/\//i.test(w) || w.startsWith("/")) return w;
  }

  // 3) .env padrão novo
  if (process && process.env && process.env.VUE_APP_API_BASE_URL) {
    const v = String(process.env.VUE_APP_API_BASE_URL);
    if (/^https?:\/\//i.test(v) || v.startsWith("/")) return v;
  }

  // 4) compatibilidade com .env antigo (/.env.production usava VUE_APP_API_BASE)
  if (process && process.env && process.env.VUE_APP_API_BASE) {
    const v = String(process.env.VUE_APP_API_BASE);
    if (/^https?:\/\//i.test(v) || v.startsWith("/")) return v;
  }

  // 5) fallback seguro
  return "https://api.flexcard.info";
}

const baseURL = resolveBase();

// Instância única
const api = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
});

// Interceptor de request: injeta Authorization se existir no localStorage
api.interceptors.request.use(
  (cfg) => {
    try {
      const raw = localStorage.getItem("flex_auth") || localStorage.getItem("usuario");
      if (raw) {
        const obj = JSON.parse(raw);
        const token = obj?.token || obj?.accessToken || obj?.Authorization;
        if (token) {
          cfg.headers = cfg.headers || {};
          // aceita "Bearer ..." ou já completo; se vier só o JWT, prefixa
          cfg.headers.Authorization = /^Bearer\s/i.test(token) ? token : `Bearer ${token}`;
        }
      }
    } catch (_) { /* silencioso */ }
    return cfg;
  },
  (err) => Promise.reject(err)
);

// Interceptor de resposta minimalista (não muda contrato)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Mantém o erro utilizável sem quebrar telas existentes
    const u = err?.config?.url || "";
    // eslint-disable-next-line no-console
    console.warn("[API ERROR]", err?.message, u);
    return Promise.reject(err);
  }
);

export default api;
